import { render } from "./AllBets.vue?vue&type=template&id=20797ea7&scoped=true"
import script from "./AllBets.vue?vue&type=script&lang=js"
export * from "./AllBets.vue?vue&type=script&lang=js"

import "./AllBets.vue?vue&type=style&index=0&id=20797ea7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20797ea7"]])

export default __exports__